import React, { useEffect, useRef } from "react";
import { Bold, Italic, Heading2, List } from "lucide-react";

const DEFAULT_TAGS = ["business_name", "creator_name", "campaign_title", "city", "reward", "budget", "date"];

export function RichTextEditor({ value, onChange, tags = DEFAULT_TAGS, insertLabel = "Insert tag" }) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== (value || "")) {
      ref.current.innerHTML = value || "";
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const emit = () => { if (ref.current) onChange(ref.current.innerHTML); };

  const cmd = (command, arg) => (e) => {
    e.preventDefault();
    ref.current?.focus();
    document.execCommand(command, false, arg);
    emit();
  };

  const insertTag = (tag) => {
    ref.current?.focus();
    document.execCommand("insertText", false, `{{${tag}}}`);
    emit();
  };

  const Btn = ({ onMouseDown, children, title, testid }) => (
    <button type="button" title={title} data-testid={testid} onMouseDown={onMouseDown}
      className="flex h-8 w-8 items-center justify-center rounded-lg border border-cardline bg-ink2/60 text-slate-300 hover:border-gold hover:text-gold">
      {children}
    </button>
  );

  return (
    <div>
      <div className="mb-2 flex flex-wrap items-center gap-1.5">
        <Btn title="Gras" testid="editor-bold" onMouseDown={cmd("bold")}><Bold size={15} /></Btn>
        <Btn title="Italique" testid="editor-italic" onMouseDown={cmd("italic")}><Italic size={15} /></Btn>
        <Btn title="Titre" testid="editor-heading" onMouseDown={cmd("formatBlock", "H2")}><Heading2 size={15} /></Btn>
        <Btn title="Liste" testid="editor-list" onMouseDown={cmd("insertUnorderedList")}><List size={15} /></Btn>
        <select data-testid="editor-insert-tag" defaultValue=""
          onChange={(e) => { if (e.target.value) { insertTag(e.target.value); e.target.value = ""; } }}
          className="ml-1 rounded-lg border border-cardline bg-ink2/60 px-2 py-1.5 text-xs text-slate-300 outline-none focus:border-gold">
          <option value="">{insertLabel}</option>
          {tags.map((tg) => <option key={tg} value={tg}>{`{{${tg}}}`}</option>)}
        </select>
      </div>
      <div ref={ref} contentEditable suppressContentEditableWarning data-testid="contract-editor"
        onInput={emit}
        className="contract-prose min-h-[220px] max-h-[360px] overflow-y-auto rounded-xl border border-cardline bg-ink2/60 px-4 py-3 text-sm leading-relaxed text-slate-200 outline-none focus:border-gold" />
    </div>
  );
}
